import { RentalLeaseType } from './RentalLeaseType';

export const RentalLeaseTypeOptions = [
    {
        id: RentalLeaseType.Annual,
        shortName: 'Annual',
        name: 'Annual',
    },
    {
        id: RentalLeaseType.MonthToMonth,
        shortName: 'MTM',
        name: 'Month-To-Month',
    },
    {
        id: RentalLeaseType.Vacation,
        shortName: 'Vacation',
        name: 'Vacation',
    },
];
